import { PropTypes, React, styled } from '../../lib/imports';
import { Text, Image } from '../../components';

const HeatStreakBanner = styled.div`
  margin-top: 24px;
  padding-right: ${({ theme }) => theme.spacings.byte};
  padding-left: ${({ theme }) => theme.spacings.byte};
`;

const HeatStreakBannerTop = styled.div`
  display: flex;
  align-items: center;
`;

const HeatStreakBannerImage1 = styled(Image)`
  max-width: 75px;
  flex: 1;
`;

const HeatStreakBannerImage2 = styled(Image)`
  margin-top: ${({ theme }) => theme.spacings.mega};
  padding-right: 14px;
  padding-left: 14px;
`;

const HeatStreakBannerTextContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacings.mega};
  flex: 3;
`;
const HeatStreakBannerTitle = styled(Text)`
  font-size: ${({ theme }) => theme.typography.text.tera.fontSize};
  font-weight: 700;
  letter-spacing: ${({ theme }) => theme.typography.text.peta.letterSpacing};
`;
const HeatStreakBannerText = styled(Text)`
  font-size: ${({ theme }) => theme.typography.text.giga.fontSize};
  letter-spacing: ${({ theme }) => theme.typography.text.giga.letterSpacing};
`;

export const PlayoffHeatStreakBanner = ({
  heatStreakBannerImg1Src,
  heatStreakBannerImg2Src,
  playoffHeatStreakBannerTitle,
  playoffHeatStreakBannerText,
}) => {
  return (
    <HeatStreakBanner>
      <HeatStreakBannerTop>
        <HeatStreakBannerImage1 src={heatStreakBannerImg1Src} />
        <HeatStreakBannerTextContainer>
          <HeatStreakBannerTitle>{playoffHeatStreakBannerTitle}</HeatStreakBannerTitle>
          <HeatStreakBannerText>{playoffHeatStreakBannerText}</HeatStreakBannerText>
        </HeatStreakBannerTextContainer>
      </HeatStreakBannerTop>
      <HeatStreakBannerImage2 src={heatStreakBannerImg2Src} />
    </HeatStreakBanner>
  );
};

PlayoffHeatStreakBanner.propTypes = {
  heatStreakBannerImg1Src: PropTypes.string,
  heatStreakBannerImg2Src: PropTypes.string,
  playoffHeatStreakBannerTitle: PropTypes.string,
  playoffHeatStreakBannerText: PropTypes.string,
};
